module.exports = __webpack_public_path__ + "img/Thumnail2.cc8f5a1b.jpg";